
import React from 'react';
import { Lead } from '@/components/leads/types';
import { DetailItem } from '../DetailItem';
import { EditableDetailItem } from '../EditableDetailItem';
import { Briefcase, Info, Globe, Star, FileText } from 'lucide-react';

interface OpportunityDetailsSectionProps {
  lead: Lead;
  handleFieldSave: (leadId: string, fieldName: keyof Lead, value: any) => Promise<void>;
  isUpdatingLead: boolean;
}

export const OpportunityDetailsSection: React.FC<OpportunityDetailsSectionProps> = ({ lead, handleFieldSave, isUpdatingLead }) => {
  return (
    <div className="py-4">
      <h3 className="text-md font-semibold mb-3 text-gray-800 flex items-center"><Info size={18} className="mr-2 text-primary"/>Opportunity Details</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-1">
        <EditableDetailItem 
            icon={<Briefcase size={16} />} 
            label="Job Title (Lead Source)" 
            value={lead.job_title}
            fieldName="job_title"
            leadId={lead.id}
            onSave={handleFieldSave}
            inputType="text"
            isLoading={isUpdatingLead}
        />
         {lead.job_posting_url && (
          <DetailItem
            icon={<Globe size={16} />}
            label="Original Job Posting"
            value="View Job Posting"
            isLink={true}
            linkHref={lead.job_posting_url}
            linkText="View Job Posting"
          />
        )}
        <EditableDetailItem 
            icon={<Star size={16} />} 
            label="Lead Score" 
            value={lead.lead_score}
            fieldName="lead_score"
            leadId={lead.id}
            onSave={handleFieldSave}
            inputType="number"
            isLoading={isUpdatingLead}
        />
        <EditableDetailItem
          icon={<FileText size={16} />} 
          label="Job Description" 
          value={lead.job_description} 
          fieldName="job_description"
          leadId={lead.id}
          onSave={handleFieldSave}
          inputType="textarea"
          className="md:col-span-2"
          isLoading={isUpdatingLead}
        />
      </div>
    </div>
  );
};
